import React from 'react'

const KioskModeContext = React.createContext({
  toggleKioskMode: () => { },
  setProjectFirst: () => { },
  setByUrl: (accountId: String | undefined, projectId: String | undefined) => { },
})

export default KioskModeContext